import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { DEFAULT_LANGUAGE_CODE, SUPPORTED_LANGUAGES } from "./language";
import { RESOURCES } from "./resources";

const i18nInstance: ReturnType<typeof i18next.createInstance> = i18next.createInstance();
await i18nInstance
  .use(
    new LanguageDetector(null, {
      caches: [],
      order: ["path"],
    }),
  )
  .use(initReactI18next)
  .init({
    resources: RESOURCES,
    fallbackLng: DEFAULT_LANGUAGE_CODE,
    supportedLngs: Object.keys(SUPPORTED_LANGUAGES),
    interpolation: {
      escapeValue: false,
    },
  });

export { i18nInstance };
